import React, { type ReactNode } from 'react';

export interface V2PageWrapperProps {
    children: ReactNode;
    noBgPattern?: boolean;
    className?: string;
}

const V2PageWrapper: React.FC<V2PageWrapperProps> = ({
    children,
    noBgPattern = false,
    className = '',
}) => {

    return (
        <div
            className={`relative min-h-full p-[var(--v2-space-6)] v2-animate-fade-in-up ${className}`.trim()}
        >
            {!noBgPattern && (
                <div
                    className="absolute inset-0 pointer-events-none opacity-0 dark:opacity-[0.22] transition-opacity"
                    aria-hidden="true"
                >
                    <div
                        className="absolute inset-0"
                        style={{
                            backgroundImage: `radial-gradient(circle at 1px 1px, rgba(74,140,210,0.35) 0.5px, transparent 0)`,
                            backgroundSize: '52px 52px',
                        }}
                    />
                </div>
            )}

            <div
                className="relative z-10 mx-auto w-full text-[var(--v2-font-body)] text-[var(--v2-text-primary)]"
            >
                {children}
            </div>
        </div>
    );
};

export default V2PageWrapper;
